import { render, staticRenderFns } from "./details_model.vue?vue&type=template&id=f342e35a&scoped=true&"
import script from "./details_model.vue?vue&type=script&lang=js&"
export * from "./details_model.vue?vue&type=script&lang=js&"
import style0 from "./details_model.vue?vue&type=style&index=0&id=f342e35a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f342e35a",
  null
  
)

export default component.exports